"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const H3_1 = __importDefault(require("../../H3"));
const Button_1 = __importDefault(require("../../Button/Button"));
const Paragraph_1 = __importDefault(require("../../Paragraph"));
const Link_1 = __importDefault(require("../../Link"));
const sendEvent = ({ category = "Buy Widget", action, label }, cb) => {
    if (!window.ga)
        cb();
    const tracker = window.ga.getByName("bitcoincom-buy-widget");
    if (tracker !== null) {
        let options;
        if (cb !== null)
            options = { hitCallback: cb };
        tracker.send("event", category, action, label, options);
    }
    else {
        cb();
    }
};
const redirectToLocal = () => {
    sendEvent({
        category: "Buy Widget",
        action: "Redirect to Local",
        label: "Users in unsupported regions that user visit local.bitcoin.com",
    }, () => {
        // window.location = new Location();
        window.location.href = "https://local.bitcoin.com";
    });
};
const Unsupported = () => {
    return (react_1.default.createElement(styled_1.Content, null,
        react_1.default.createElement(styled_1.TextWrapper, null,
            react_1.default.createElement(H3_1.default, null, "Unsupported Region"),
            react_1.default.createElement(Paragraph_1.default, null,
                "Sorry, our credit card supplier does not serve your region yet. Please visit",
                " ",
                react_1.default.createElement(Link_1.default, { newTab: true, href: "https://local.bitcoin.com", onClick: (e) => {
                        e.preventDefault();
                        redirectToLocal();
                    } }, "local.bitcoin.com"),
                " ",
                "to buy Bitcoin Cash (BCH) using any payment method in all parts of the world!")),
        react_1.default.createElement(Button_1.default, { design: Button_1.default.Designs.Primary, onClick: () => {
                redirectToLocal();
            } }, "Visit")));
};
exports.default = Unsupported;
//# sourceMappingURL=Unsupported.js.map